import script from "./HomeSportGames.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSportGames.vue?vue&type=script&setup=true&lang=js"

import "./HomeSportGames.vue?vue&type=style&index=0&id=5b36bedb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b36bedb"]])

export default __exports__